export default "__VITE_ASSET__RlBAU7Sv__"